import { render, staticRenderFns } from "./PracticeProviderAdd.vue?vue&type=template&id=78c01dcc&scoped=true&"
import script from "./PracticeProviderAdd.vue?vue&type=script&lang=js&"
export * from "./PracticeProviderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c01dcc",
  null
  
)

export default component.exports